import React, { useEffect, useState } from 'react'
import { connect, useDispatch } from 'react-redux'
import { RootState } from 'Store'
import { Col, Radio, Row, Space, Statistic, Tooltip } from 'antd'
import styled from 'styled-components'
import Theme, { MyTheme } from 'Components/common/Theme'
import IncomeChart from './IncomeChart'
import {
  menuPaymentType,
  menuPaymentTypePackageC,
  menuPaymentTypePackageCWithoutOnline,
  menuSupplierPaymentTypes,
} from 'helpers/constanst'
import {
  currentDate,
  formatDateWithoutTime,
  getFirstdayOfMonth,
  getIncomeChart,
  getLast1Month,
  getLastdayOfMonth,
  getMonday,
  getSunday,
  getSupplierIncomeChart,
  numberWithComma,
  toDateQuery,
} from 'helpers/format'
import { RangeDateItem } from 'Components/form'
import {
  PaymentReq,
  ReturnDashboardReq,
  SupplierDashboardReq,
  TerminalProfitReq,
} from 'Store/dashboard/types'
import {
  getReturnDashboardAPI,
  getSupplierDashboardAPI,
  getTerminalProfitAPI,
  paymentDashboardAPI,
} from 'Store/dashboard/api'
import {
  selectEventDashboard,
  selectPaymentsDashboard,
  selectProfitEventDashboard,
  selectReturnDashboard,
  selectSupplierDashboard,
  selectTerminalProfitDashboard,
} from 'Store/dashboard/selector'
import { selectCurrentUser } from 'Store/user/selector'
import { cloneDeep } from 'lodash'
import ReturnIcon from '../../../assets/img/return.png'
import { selectIsPackageC } from 'Store/pos/selector'
import SupplierIncomeChart from './SupplierIncomeChart'
import { themeConfig } from 'config'
import { sortingByNumber } from 'helpers/sorting'
import { InfoCircleFilled } from '@ant-design/icons'

type Props = {} & ReduxProps

const Income: React.FunctionComponent<Props> = props => {
  const dispatch = useDispatch()
  const {
    currentUser,
    payments,
    isPackageC,
    supplierData,
    returnSummaryData,
    profitData,
    profitEvent,
  } = props
  const initFilter = {
    start_date: getLast1Month(),
    end_date: currentDate(),
    dateType: 'monthAgo',
  }

  const [filter, setFilter] = useState(cloneDeep(initFilter))
  const enableProductOnline = themeConfig?.component?.elementOnlineProduct

  const handleChangeDate = (statDate: string, endDate: string) => {
    setFilter({
      ...filter,
      start_date: statDate,
      end_date: endDate,
      dateType: '',
    })
  }

  const handleChangeType = (type: string) => {
    let statDate = getLast1Month()
    let endDate = currentDate()
    if (type === 'day') {
      statDate = currentDate()
      endDate = currentDate()
    }
    if (type === 'week') {
      statDate = getMonday()
      endDate = getSunday()
    }
    if (type === 'month') {
      statDate = getFirstdayOfMonth()
      endDate = getLastdayOfMonth()
    }
    if (type === 'monthAgo') {
      statDate = getLast1Month()
      endDate = currentDate()
    }
    setFilter({
      ...filter,
      start_date: statDate,
      end_date: endDate,
      dateType: type,
    })
  }

  const onGetData = (): void => {
    const req: PaymentReq = {
      mid: currentUser?.activeMerchant?.id || 0,
      start_date: toDateQuery(filter.start_date),
      end_date: toDateQuery(filter.end_date),
    }

    dispatch(paymentDashboardAPI(req, currentUser.accessToken))
  }

  const onGetSupplierDashboardData = (): void => {
    const req: SupplierDashboardReq = {
      mid: currentUser?.activeMerchant?.id || 0,
      start_date: toDateQuery(filter.start_date),
      end_date: toDateQuery(filter.end_date),
    }

    dispatch(getSupplierDashboardAPI(req, currentUser.accessToken))
  }

  const onGetReturnSummaryDashboardData = (): void => {
    const req: ReturnDashboardReq = {
      mid: currentUser?.activeMerchant?.id || 0,
      start_date: toDateQuery(filter.start_date),
      end_date: toDateQuery(filter.end_date),
    }

    dispatch(getReturnDashboardAPI(req, currentUser.accessToken))
  }

  const onGetTerminalProfitDashboardData = (): void => {
    const req: TerminalProfitReq = {
      mid: currentUser?.activeMerchant?.id || 0,
      start_date: toDateQuery(filter.start_date),
      end_date: toDateQuery(filter.end_date),
    }

    dispatch(getTerminalProfitAPI(req, currentUser.accessToken))
  }

  useEffect(() => {
    if (currentUser?.accessToken) {
      onGetData()
    }
  }, [filter])

  useEffect(() => {
    if (currentUser?.accessToken && isPackageC) {
      onGetSupplierDashboardData()
      onGetReturnSummaryDashboardData()
      onGetTerminalProfitDashboardData()
    }
  }, [filter, isPackageC])

  const valStyle = {
    color: Theme.colors.black,
    fontFamily: Theme.fontFamily.regular,
    fontSize: Theme.typography.h4,
  }

  const paymentType = isPackageC
    ? enableProductOnline
      ? menuPaymentTypePackageC
      : menuPaymentTypePackageCWithoutOnline
    : menuPaymentType

  const getValue = (type: string, paymentChanels: any[]) => {
    const result = paymentChanels.find(item => item?.payment_channel === type)
    return result
  }

  const getOrderValue = (type: string, paymentChanels: any[]) => {
    const result = paymentChanels.find(item => item?.payment_type === type)
    return result
  }

  const sumPaymentChannel = (paymentChanels: any[]) => {
    let count = 0
    paymentChanels.forEach(item => (count += item.total_payment))
    return count
  }

  const countReturn = (channel: string) => {
    const result = returnSummaryData?.find(item => item.channel === channel)
    return { amount: result?.total_amount || 0, quantity: result?.total_quantity || 0 }
  }

  const sumReturn = () => {
    let amount = 0
    let quantity = 0
    returnSummaryData?.forEach(item => {
      amount += item?.total_amount || 0
      quantity += item?.total_quantity || 0
    })
    return { amount, quantity }
  }

  const ReturnPayment = (
    <div>
      <BoxTitle>
        ภาพรวมรายการรับคืนสินค้า{' '}
        <Unit>
          {`(ประจำวันที่ ${formatDateWithoutTime(filter.start_date)} - ${formatDateWithoutTime(
            filter.end_date,
          )})`}
        </Unit>
      </BoxTitle>
      <br />
      <Space>
        <Icon src={ReturnIcon} />
        <Description>
          รายการรับคืนสินค้า
          <Unit> (เฉพาะรายการรับคืนสินค้าที่สถานะการคืนเงินสำเร็จแล้วเท่านั้น)</Unit>
        </Description>
      </Space>
      <Item>
        <Row gutter={[16, 16]}>
          <Col md={12} xs={24}>
            <Statistic
              title="จำนวนเงินคืน"
              value={numberWithComma(sumReturn().amount, true)}
              suffix={<Unit>บาท</Unit>}
              valueStyle={valStyle}
            />
          </Col>
          <Col md={12} xs={24}>
            <Statistic
              valueStyle={valStyle}
              title="จำนวนรายการคืนสินค้า"
              value={sumReturn().quantity}
              suffix={<Unit>รายการ</Unit>}
              formatter={(val: any) => numberWithComma(val || 0)}
            />
          </Col>
        </Row>
      </Item>
    </div>
  )

  const IncomeSummary = (
    <Row gutter={[8, 8]}>
      <Col md={9} xs={24}>
        <BorderBox>
          <Row>
            <Col md={16} xs={24}>
              <SmallTitle>ยอดขายทั้งหมด (บาท)</SmallTitle>
              <NumberSumPrimary>{numberWithComma(payments?.total_price, true)}</NumberSumPrimary>
            </Col>
            <Col md={8} xs={24}>
              <SmallTitle>จำนวนบิลทั้งหมด</SmallTitle>
              <NumberSum>{numberWithComma(sumPaymentChannel(payments?.success_payments || []))}</NumberSum>
            </Col>
          </Row>
        </BorderBox>
      </Col>
      <Col md={5} xs={24}>
        <BorderBox>
          <SmallTitle>
            กำไร (บาท)&nbsp;&nbsp;
            <Tooltip
              placement="top"
              title={'หมายเหตุ : กำไรที่แสดงนี้ จะยังไม่รวมรายการขายที่มีสถานะเป็น รายการสั่งซื้อใหม่'}
            >
              <InfoCircleFilled />
            </Tooltip>
          </SmallTitle>
          <NumberSum>{numberWithComma(profitData?.Terminal?.profit || 0, true)}</NumberSum>
        </BorderBox>
      </Col>
      <Col md={5} xs={24}>
        <BorderBox>
          <SmallTitle>ค่าใช้จ่าย (ส่วนลดท้ายบิล)</SmallTitle>
          <NumberSum>{numberWithComma(profitData?.Terminal?.discount || 0, true)}</NumberSum>
        </BorderBox>
      </Col>
      <Col md={5} xs={24}>
        <BorderBox>
          <SmallTitle>คืนสินค้า (บาท)</SmallTitle>
          <NumberSum>{numberWithComma(countReturn('pos').amount || 0, true)}</NumberSum>
        </BorderBox>
      </Col>
    </Row>
  )

  const mapPaymentTypeWithValue = () => {
    const newpaymentType = paymentType.map((item: any) => {
      const result = getOrderValue(item.value, payments?.success_payments || [])
      item.price = result?.total_price || 0
      item.bill = result?.total_payment || 0
      return item
    }) as any
    return newpaymentType
  }

  const sortingPayment = sortingByNumber(mapPaymentTypeWithValue(), 'desc', 'price')

  const IncomeChartContent = (
    <Row gutter={[8, 16]} align="middle">
      <Col md={8} xs={24}>
        <IncomeChart paymentData={payments} isPackageC={isPackageC} />
      </Col>
      <Col md={16} xs={24}>
        <Row>
          <Col md={10} xs={10}></Col>
          <Col md={7} xs={7}>
            <SmallTitle>ยอดขาย (บาท)</SmallTitle>
          </Col>
          <Col md={7} xs={7}>
            <SmallTitle>บิล</SmallTitle>
          </Col>
        </Row>
        {sortingPayment.map((item, index) => {
          const type = getIncomeChart(item.value)
          return (
            <BorderTop key={index}>
              <Row>
                <Col md={10} xs={10}>
                  <Space>
                    <Point style={{ backgroundColor: type.color }} />
                    <Legend>{type.text}</Legend>
                  </Space>
                </Col>
                <Col md={7} xs={7}>
                  <LegendNumber>{numberWithComma(item.price || 0, true)}</LegendNumber>
                </Col>
                <Col md={7} xs={7}>
                  <LegendNumber>{numberWithComma(item?.bill || 0)} </LegendNumber>
                </Col>
              </Row>
            </BorderTop>
          )
        })}
        {enableProductOnline && (
          <BorderTop>
            <Row>
              <Col md={10} xs={10}>
                <Space>
                  <Point style={{ backgroundColor: '#fff' }} />
                  <Legend>รายการรอชำระเงิน (รอชำระเงินภายใน 3 วัน)</Legend>
                </Space>
              </Col>
              <Col md={7} xs={7}>
                <Legend>{numberWithComma(payments?.pending_payments?.total_price || 0, true)}</Legend>
              </Col>
              <Col md={7} xs={7}>
                <Legend>{numberWithComma(payments?.pending_payments?.total_payment)} </Legend>
              </Col>
            </Row>
          </BorderTop>
        )}
      </Col>
    </Row>
  )

  const SupplierIncomeSummary = (
    <Row gutter={[8, 8]} align="top">
      <Col md={10} xs={24}>
        <BorderBox>
          <Row>
            <Col md={16} xs={24}>
              <SmallTitle>ยอดขายทั้งหมด (บาท)</SmallTitle>
              <NumberSumPrimary>
                {numberWithComma(supplierData?.sum_all_sales?.total_amount || 0, true)}
              </NumberSumPrimary>
            </Col>
            <Col md={8} xs={24}>
              <SmallTitle>จำนวนบิลทั้งหมด</SmallTitle>
              <NumberSum>{numberWithComma(supplierData?.sum_all_sales?.total_items)}</NumberSum>
            </Col>
            <Col md={24} xs={24}>
              <SmallTitleSecond>ชำระสำเร็จ (บาท)</SmallTitleSecond>
              <NumberSumSecond>
                {numberWithComma(supplierData?.sum_by_payment_channel?.total_amount || 0, true)}
              </NumberSumSecond>
            </Col>
            <Col md={24} xs={24}>
              <SmallTitleSecond>รอชำระเงิน (บาท)</SmallTitleSecond>
              <NumberSumSecond>
                {numberWithComma(supplierData?.sum_all_waiting_payment?.total_amount, true)}
              </NumberSumSecond>
            </Col>
          </Row>
        </BorderBox>
      </Col>
      <Col md={14} xs={24}>
        <Row gutter={[8, 8]} align="middle">
          <Col md={12} xs={24}>
            <BorderBox>
              <SmallTitle>กำไร (บาท)</SmallTitle>
              <NumberSum>{numberWithComma(profitData?.Supplier?.profit || 0, true)}</NumberSum>
            </BorderBox>
          </Col>
          <Col md={12} xs={24}>
            <BorderBox>
              <SmallTitle>ค่าใช้จ่าย (ส่วนลดท้ายบิล)</SmallTitle>
              <NumberSum>{numberWithComma(profitData?.Supplier?.discount || 0, true)}</NumberSum>
            </BorderBox>
          </Col>
          <Col md={12} xs={24}>
            <BorderBox>
              <SmallTitle>
                {/* ยอดเงินที่ได้รับชำระ ณ วันที่ {formatDateWithoutTime(filter.start_date)} -{' '}
                {formatDateWithoutTime(filter.end_date)} */}
                ยอดเงินที่ได้รับชำระ (บาท)
              </SmallTitle>
              <NumberSum>
                {numberWithComma(supplierData?.sum_payment_by_payment_channel?.total_amount || 0, true)}
              </NumberSum>
            </BorderBox>
          </Col>
          <Col md={12} xs={24}>
            <BorderBox>
              <SmallTitle>คืนสินค้า (บาท)</SmallTitle>
              <NumberSum>{numberWithComma(countReturn('supplier').amount, true)}</NumberSum>
            </BorderBox>
          </Col>
        </Row>
      </Col>
    </Row>
  )

  const mapSupPaymentTypeWithValue = () => {
    const newpaymentType = cloneDeep(menuSupplierPaymentTypes).map((item: any) => {
      const result = getValue(
        item.value,
        supplierData?.sum_payment_by_payment_channel?.payment_channels || [],
      )
      item.price = result?.total_amount || 0
      item.bill = 0
      return item
    }) as any
    return newpaymentType
  }

  const sortingSupPayment = sortingByNumber(mapSupPaymentTypeWithValue(), 'desc', 'price')

  const SupplierIncomeChartContent = (
    <Row gutter={[8, 16]} align="middle">
      <Col md={8} xs={24}>
        <SupplierIncomeChart paymentData={supplierData} />
      </Col>
      <Col md={16} xs={24}>
        <Row>
          <Col md={12} xs={12}></Col>
          <Col md={12} xs={12}>
            <SmallTitle>ยอดขาย (บาท)</SmallTitle>
          </Col>
        </Row>
        {sortingSupPayment.map((item, index) => {
          const type = getSupplierIncomeChart(item.value)
          return (
            <BorderTop key={index}>
              <Row>
                <Col md={12} xs={12}>
                  <Space>
                    <Point style={{ backgroundColor: type.color }} />
                    <Legend>{type.text}</Legend>
                  </Space>
                </Col>
                <Col md={12} xs={12}>
                  <LegendNumber>{numberWithComma(item.price || 0, true)}</LegendNumber>
                </Col>
              </Row>
            </BorderTop>
          )
        })}
      </Col>
    </Row>
  )

  const OrderReport = (
    <BoxWrapper>
      <BoxTitle>
        ภาพรวมยอดขายผ่านระบบขายหน้าร้าน{enableProductOnline ? ' และขายออนไลน์' : ''}{' '}
        <Unit>
          {`(ประจำวันที่ ${formatDateWithoutTime(filter.start_date)} - ${formatDateWithoutTime(
            filter.end_date,
          )})`}
        </Unit>
      </BoxTitle>
      <br />
      <Row gutter={[16, 16]} align="middle" justify="center">
        <Col lg={24} md={24} xs={24} sm={24}>
          {IncomeSummary}
        </Col>
        <Col>
          <SecondBoxTitle>ยอดขายแบ่งตามประเภทการชำระเงิน</SecondBoxTitle>
        </Col>
        <Col lg={24} md={24} xs={24} sm={24}>
          {IncomeChartContent}
        </Col>
      </Row>
    </BoxWrapper>
  )

  const SupplierReport = (
    <BoxWrapper>
      <BoxTitle>
        ภาพรวมยอดขายผ่านระบบเสนอขายราคาพิเศษ{' '}
        <Unit>
          {`(ประจำวันที่ ${formatDateWithoutTime(filter.start_date)} - ${formatDateWithoutTime(
            filter.end_date,
          )})`}
        </Unit>
      </BoxTitle>
      <br />
      <Row gutter={[16, 16]} align="middle" justify="center">
        <Col lg={24} md={24} xs={24} sm={24}>
          {SupplierIncomeSummary}
        </Col>
        <Col>
          <SecondBoxTitle>
            {' '}
            ยอดเงินที่ได้รับชำระ ณ วันที่ {formatDateWithoutTime(filter.start_date)} -{' '}
            {formatDateWithoutTime(filter.end_date)} แบ่งตามประเภทการชำระเงิน
          </SecondBoxTitle>
        </Col>
        <Col lg={24} md={24} xs={24} sm={24}>
          {SupplierIncomeChartContent}
        </Col>
      </Row>
    </BoxWrapper>
  )

  return (
    <Row gutter={[16, 16]}>
      <Col span={24}>
        <Row gutter={[16, 16]} justify="space-between" align="bottom">
          <Col md={6} sm={24} xs={24}>
            <BigTitle>รายงานสรุปยอดขาย</BigTitle>
          </Col>
          <Col>
            <Row justify="end" gutter={[16, 8]} align="middle">
              <Col>
                <DateButtonGroup
                  size="large"
                  buttonStyle="solid"
                  value={filter.dateType}
                  onChange={e => handleChangeType(e.target.value)}
                >
                  <DateButton value="day">วันนี้</DateButton>
                  <DateButton value="week">สัปดาห์นี้</DateButton>
                  <DateButton value="month">เดือนนี้</DateButton>
                  <DateButton value="monthAgo">ย้อนหลัง 1 เดือน</DateButton>
                </DateButtonGroup>
              </Col>
              <Col>
                <RangeDateItem
                  placeHolder={['วันที่เริ่มต้น', 'วันที่สิ้นสุด']}
                  onChange={handleChangeDate}
                  startDate={filter.start_date}
                  endDate={filter.end_date}
                  allowClear={false}
                />
              </Col>
            </Row>
          </Col>
        </Row>
      </Col>
      <Col md={24} xs={24} sm={24}>
        {OrderReport}
      </Col>
      {isPackageC && (
        <Col md={24} xs={24} sm={24}>
          {SupplierReport}
        </Col>
      )}
      {isPackageC && (
        <Col md={24} xl={24} sm={24} xs={24}>
          <BoxWrapper>{ReturnPayment}</BoxWrapper>
        </Col>
      )}
    </Row>
  )
}

const BoxWrapper = styled.div`
  padding: 20px;
  background-color: ${(props: { theme: MyTheme }): string => props.theme.colors.white};
  border-radius: 20px;
  border-color: transparent;
`

const BoxTitle = styled.div`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body3};
  font-family: ${(props: { theme: MyTheme }): string => props.theme.fontFamily.bold};
`

const BigTitle = styled.div`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body1};
  font-family: ${(props: { theme: MyTheme }): string => props.theme.fontFamily.bold};
`

const SecondBoxTitle = styled.div`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body3};
  font-family: ${(props: { theme: MyTheme }): string => props.theme.fontFamily.bold};
  //color: ${(props: { theme: MyTheme }): string => props.theme.colors.grey};
`

const Legend = styled.span`
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.black};
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
  font-family: ${(props: { theme: MyTheme }): string => props.theme.fontFamily.primary};
`

const LegendNumber = styled(Legend)`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
`

const Point = styled.div`
  width: 12px;
  height: 12px;
  border-radius: 50%;
`

const Icon = styled.img`
  height: 40px;
`

const Description = styled.div`
  padding-left: 10px;
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.black};
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body3};
`

const Unit = styled(Legend)`
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.grey};
`

const Item = styled.div`
  margin-top: 20px;
`

const BorderTop = styled.div`
  padding: 5px 0;
  border-top: 1px solid ${(props: { theme: MyTheme }): string => props.theme.colors.whitebg};
`

const SmallTitle = styled.span`
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.grey};
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
  font-family: ${(props: { theme: MyTheme }): string => props.theme.fontFamily.bold};
`

const BorderBox = styled.div`
  width: 100%;
  border: 1.5px solid ${(props: { theme: MyTheme }): string => props.theme.colors.whitebg};
  padding: 10px;
  border-radius: 5px;
`

const NumberSum = styled.div`
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.black};
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.h2sm};
  font-family: ${(props: { theme: MyTheme }): string => props.theme.fontFamily.bold};
  overflow-wrap: break-word;
`

const NumberSumSecond = styled(NumberSum)`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.h5};
`

const NumberSumPrimary = styled(NumberSum)`
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.primary};
`

// const SmallTitleGreen = styled(SmallTitle)`
//   color: ${(props: { theme: MyTheme }): string => props.theme.colors.success};
//   font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
//   font-family: ${(props: { theme: MyTheme }): string => props.theme.fontFamily.bold};
// `

// const SmallTitleRed = styled(SmallTitle)`
//   color: ${(props: { theme: MyTheme }): string => props.theme.colors.error};
//   font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
//   font-family: ${(props: { theme: MyTheme }): string => props.theme.fontFamily.bold};
// `

const SmallTitleSecond = styled(SmallTitle)`
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.grey};
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
  font-family: ${(props: { theme: MyTheme }): string => props.theme.fontFamily.regular};
`

const DateButton = styled(Radio.Button)`
  // width: 100px;
  text-align: center;
`

const DateButtonGroup = styled(Radio.Group)`
  .ant-radio-button-wrapper:last-child {
    border-radius: 0 6px 6px 0;
  }

  .ant-radio-button-wrapper:first-child {
    border-radius: 6px 0 0 6px;
  }
`

const mapStateToProps = (state: RootState) => {
  return {
    currentUser: selectCurrentUser(state),
    payments: selectPaymentsDashboard(state),
    supplierData: selectSupplierDashboard(state),
    returnSummaryData: selectReturnDashboard(state),
    isPackageC: selectIsPackageC(state),
    profitData: selectTerminalProfitDashboard(state),
    profitEvent: selectProfitEventDashboard(state),
    event: selectEventDashboard(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>

export default connect(mapStateToProps)(Income)
